import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { ICreds, IPollingResponse } from "../../types/login.types";

const initialState: ICreds | IPollingResponse = {
  pollingIntervalId: null,
  access_token: null,
  id: null,
  instance_url: null,
  issued_at: null,
  refresh_token: null,
  scope: null,
  signature: null,
  token_type: null,

};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setPollingIntervalId: (state, _action) => {
      return { ...state, pollingIntervalId: _action.payload };
    },
    setAuthenticatedCredentials: (state, _action) => {
      return { ...state, ..._action.payload };
    },
  },
});
export const getPollingIntervalId = (state: RootState) => (state.login as ICreds).pollingIntervalId;

export const { setPollingIntervalId, setAuthenticatedCredentials } = loginSlice.actions;
export default loginSlice.reducer;
